import { IMenuButton, ISubMenu } from 'common/index/services/menu-provider';
import { CustomizationMenuSubTabsEnum } from 'common/index/config/menuEnum';

export const customerGeneralContactTypesSubMenu: ISubMenu = {
    phones: {
        alias: CustomizationMenuSubTabsEnum.phones,
        name: 'settings.contact_types.phones_title'
    },
    addresses: {
        alias: CustomizationMenuSubTabsEnum.addresses,
        name: 'settings.contact_types.addresses_title'
    }
};

export const customerGeneralContactTypesMenuButtons: IMenuButton[] = Object.values(customerGeneralContactTypesSubMenu);
